import Phaser from "phaser";

export interface BaseModalConfig {
  width: number;
  height: number;
  onClose?: () => void;
}

export abstract class BaseModal extends Phaser.GameObjects.Container {
  protected overlay: Phaser.GameObjects.Rectangle;

  constructor(scene: Phaser.Scene, config: BaseModalConfig) {
    super(scene, 0, 0);

    const { width, height } = config;

    // 1) 주변 배경 어둡게 (터치/클릭도 여기서 막음)
    this.overlay = scene.add
      .rectangle(width / 2, height / 2, width, height, 0x000000, 0.45)
      .setInteractive(); // input 먹어서 뒤쪽 클릭 방지

    // overlay 클릭은 아무 동작 안 하게(닫히지 않게) 두는 게 기본
    this.overlay.on("pointerdown", () => {});

    this.add(this.overlay);

    scene.add.existing(this);
  }

  /** 모달 열릴 때 애니메이션이 필요하면 여기서 */
  open() {
    this.setVisible(true);
    this.setActive(true);
  }

  /** 모달 닫기 */
  close() {
    this.destroy(true);
  }
}
